export class AccountDeletionRequestCodeModel {
  public code: string;
  public phone: number;
  public dob: Date;

}

export class AccountDeletionConfirmModel extends AccountDeletionRequestCodeModel {
  public deleteDataRequest: boolean;
}
